import { ResizeObserver as Polyfill } from '@juggle/resize-observer';

export default () => {
  if (!window.ResizeObserver) {
    window.ResizeObserver = Polyfill;
  }
};
